import {VStack} from '@chakra-ui/react';
import {TitledSection} from 'components/layouts/aside-layout';
import {OrderProduct} from 'components/shared';
import {FC} from 'react';
import {TranslationKeys} from 'translations';
import {IOrderItem} from 'types';

interface Props {
  items: IOrderItem[];
  t: (term: TranslationKeys) => string;
}

export const OrderItemList: FC<Props> = ({t, items}) => {
  const currency = t('CURRENCY');
  const title = t('ORDERED_PRODUCTS');

  if (!items?.length) return null;

  const allIndividualItems: any[] = [];

  items.forEach((item) => {
    const isWeightedProduct = item.product?.is_weighted_product;

    if (isWeightedProduct) {
      allIndividualItems.push({
        ...item,
        id: item.product_id,
        _isWeightedProduct: true,
        quantity: item.quantity,
      });
    } else if (item.individual_items?.length > 0) {
      item.individual_items.forEach((individualItem) => {
        allIndividualItems.push({
          ...item,
          id: item.product_id,
          instructions: individualItem.instructions,
          options: individualItem.options,
        });
      });
    }
  });

  const groupedItemsMap = new Map<string, any>();

  allIndividualItems.forEach((item) => {
    const optionsKey = JSON.stringify(item.options || []);
    const groupKey = `${item.product_id}-${optionsKey}`;

    if (groupedItemsMap.has(groupKey)) {
      if (item._isWeightedProduct) {
        groupedItemsMap.get(groupKey).quantity += item.quantity;
      } else {
        groupedItemsMap.get(groupKey).quantity++;
      }
    } else {
      groupedItemsMap.set(groupKey, {
        ...item,
        quantity: item._isWeightedProduct ? item.quantity : 1,
      });
    }
  });

  const groupedItems = Array.from(groupedItemsMap.values());

  return (
    <TitledSection title={`${groupedItems.length} ${title}`}>
      <VStack spacing={5} justifyContent="stretch">
        {groupedItems.map((item, index) => (
          <OrderProduct
            key={`${item.product_id}-${index}`}
            data={item}
            options={item.options}
            currency={currency}
            ingredients={item.ingredients}
          />
        ))}
      </VStack>
    </TitledSection>
  );
};
